export const selectVideoStories = state => {
  return state.videoStories.storyList;
};
export const selectVideoStory = state => {
  return state.videoStories.videoStoryDetail;
};
